export default __webpack_public_path__ + "static/media/IconDesc_Zipline.256.0ac63c09.png";